import { useContext } from 'react';
import { message } from 'antd';
import { get } from 'lodash';
import { useMutation } from '@apollo/react-hooks';
import { CREATE_ALERT, ALERT_SUMMARY_QUERY } from '@api/graphql/manualAlerts';
import { FormActionContext } from '../context';

const useCreateAlert = (setSaving) => {
  const { actions: { onCancel } } = useContext(FormActionContext);
  const [createAlert] = useMutation(CREATE_ALERT, {
    update(cache, {data: { createManualAlert }}) {
      const query = ALERT_SUMMARY_QUERY();
      const cachedData: any = cache.readQuery({ query });
      const existing = get(cachedData, 'manualAlertsByType');
      existing.push(createManualAlert);
      cache.writeQuery({
        query,
        data: cachedData,
      });
    },
    onCompleted(data) {
      const { createManualAlert: { name } } = data;
      onCancel();
      setSaving(false);
      message.success(`Alert "${name}" created successfully`);
    }
  });
  return createAlert;
};

export default useCreateAlert;
